import { reportDataValueGQLFields, } from './reportDataValue.fields.js';
const BASIC_REPORT_DATA_FIELDS = {};
const ALL_REPORT_DATA_FIELDS = {
    previousValue: 'basic',
    value: 'basic',
};
export function reportDataGQLFields(fields) {
    if (fields === 'basic')
        fields = BASIC_REPORT_DATA_FIELDS;
    if (fields === 'all')
        fields = ALL_REPORT_DATA_FIELDS;
    return `
    description
    key
    type
    ${fields.value
        ? `
      value {
        ${reportDataValueGQLFields(fields.value)}
      }
    `
        : ``}
    ${fields.previousValue
        ? `
      previousValue {
        ${reportDataValueGQLFields(fields.previousValue)}
      }
    `
        : ``}
  `;
}
